module.exports = "/static/assets/e9aeb1d50663c1c105188f39fc6e7e11.png";